<template>
  <div class="row">
    <div class="col-md-auto">
      <DatePicker
        ref="calendar"
        v-model="theDate"
        @dayclick="setCalendarDate"
        @update:pages="updatePublicHolidays"
        :attributes="attributes"
        is-dark
        :first-day-of-week="firstDayOfWeek"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { DatePicker } from 'v-calendar'

export default {
  name: 'CalendarComponent',
  components: { DatePicker },
  data() {
    return {
      theDate: this.calendarDate,
      firstDayOfWeek: 2,
      attributes: [],
      // The page whose public holidays are already loaded. v-calendar 3 re-emits `update:pages` on
      // every render, and the handler sets `attributes`, which renders again - without this it is a
      // loop (and an API call per turn).
      lastPage: undefined,
    }
  },
  props: {
    calendarDate: Date,
  },
  watch: {
    calendarDate: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          const calendar = this.$refs.calendar
          calendar.move(newValue)
          this.theDate = newValue
        }
      },
    },
  },
  computed: {},
  methods: {
    setCalendarDate(selected) {
      this.$emit('set-calendar-date', selected.date)
    },
    async updatePublicHolidays(pages) {
      // v-calendar 3 emits `update:pages` with an array of pages; v2 emitted `update:to-page` with
      // one. Take the first either way.
      const newPage = Array.isArray(pages) ? pages[0] : pages
      if (!newPage) {
        return
      }

      const pageKey = `${newPage.year}-${newPage.month}`
      if (pageKey === this.lastPage) {
        return
      }
      this.lastPage = pageKey
      const holidays = await this.getPublicHolidaysForMonth(
        moment()
          .date(1)
          .month(newPage.month - 1)
          .year(newPage.year)
          .toDate()
      )

      this.attributes = [
        {
          key: 0,
          highlight: { fillMode: 'light' },
          dates: new Date(),
          order: 0,
        },
        {
          key: 1,
          highlight: { fillMode: 'outline', style: { borderColor: '#000000' } },
          dates: holidays,
          order: 0,
        },
      ]
    },
    ...mapActions('resource', ['getPublicHolidaysForMonth']),
  },
  mounted() {},
  created() {},
  unmounted() {},
}
</script>

<style scoped lang="scss">
.vc-container {
  border: 0;
  font-family: unset;
}

/*
 * The container background is set globally in app.css, not here: v-calendar 3's stylesheet loads
 * after this scoped block, so a rule here loses the cascade. The rule that used to live here also
 * named the wrong class - v3 emits `vc-dark`, not `vc-is-dark` - so it never matched at all.
 */

.vc-highlight {
  background-color: pink;
}
</style>
